import { useTranslation } from "@/Common/CustomHooks/useTranslation";

import styles from "../FaxDirectoryForm.module.scss";

interface IDirectoryOthersNamingRowProps {
    labelKey?: string;
    othersNamingInstruction?: string;
    othersNamingStructure?: string;
    className?: string;
    children: JSX.Element | JSX.Element[];
}

export function DirectoryOthersNamingRow(props: IDirectoryOthersNamingRowProps): JSX.Element {
    const { getText } = useTranslation();
    return (
        <div className={`${styles.directoryRow} ${props.className ?? ""}`}>
            {props.labelKey && <label className="bold">{getText(props.labelKey)}</label>}
            {props.othersNamingStructure && (
                <>
                    <div>
                        <span>{getText(props.othersNamingInstruction)}</span>
                    </div>
                    <div>
                        <span>{getText(props.othersNamingStructure)}</span>
                    </div>
                </>
            )}
            {props.children}
        </div>
    );
}
